<template>
  <div class="row vod-guide-viewer">
    <div class="col-md-7">
      <div class="card">
        <div class="card-content row" v-if="this.vodguidePage.data">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              @input="loadPage(pagination.currentPage)"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <label>
                <input type="search" class="form-control input-sm" placeholder="Search records" :value="searchQuery" @input="search" aria-controls="datatables">
              </label>
            </div>
          </div>
          <div class="col-sm-12">&nbsp;</div>
          <div class="col-sm-12">
            <el-table class="table-striped"
                      :data="tableData"
                      border
                      @row-click="showGuide"
                      style="width: 100%">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{ paginatorInfo.firstItem }} to {{ paginatorInfo.lastItem }} of {{ paginatorInfo.total }} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          @input="loadPage($event)"
                          :value="pagination.currentPage"
                          :per-page="paginatorInfo.perPage"
                          :total="paginatorInfo.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <div class="card guide-xml-card">
        <div class="card-header">
          <h4 class="card-title">Guide XML</h4>
        </div>
        <div class="card-content">
          <div v-html="guideXml"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import prism from 'prismjs'
import Vue from 'vue'
import {mapActions, mapGetters} from "vuex";
import {Table, TableColumn, Select, Option} from 'element-ui'
import PPagination from 'src/components/UIComponents/Pagination.vue'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)

export default {
  components: {PPagination},
  async mounted () {
    await this.loadPage(this.pagination.currentPage);
  },
  computed: {
    ...mapGetters(['vodguidePage']),
    tableData: function () {
      return this.vodguidePage.data;
    },
    paginatorInfo: function () {
      return this.vodguidePage.paginatorInfo;
    },
    guideXml: function () {
      if (this.selectedRow && this.selectedRow.guide_xml) {
        const guideXml = this.selectedRow.guide_xml.replace(/></g, ">\n<");
        return '<pre><code>' + Prism.highlight(guideXml, Prism.languages.xml, 'xml') + '</code></pre>'
      }
      return '<em>Please select row to show guide xml</em>';
    }
  },
  data () {
    return {
      pagination: {
        currentPage: 1,
        perPage: 50,
        perPageOptions: [20, 50, 100, 200, 300]
      },
      searchQuery: '',
      tableColumns: [
        {
          prop: 'title',
          label: 'Title',
          minWidth: 200
        },
        {
          prop: 'created_at',
          label: 'Created Date',
          minWidth: 100
        },
      ],
      selectedRow: null
    }
  },
  methods: {
    ...mapActions(['vodguideFetchList']),
    showGuide: function (row) {
      this.selectedRow = row;
    },
    loadPage: async function (page) {
      const search = this.searchQuery ? '%' + this.searchQuery + '%' : "%";
      await this.vodguideFetchList({page, search, perPage: this.pagination.perPage});
      this.pagination.currentPage = page;
    },
    search: _.debounce(async function (e) {
      this.searchQuery = e.target.value;
      await this.loadPage(this.pagination.currentPage)
    }, 500),
  }
}
</script>
<style>
.card.guide-xml-card {
  position: sticky;
  top: 10px;
}

.guide-xml-card .card-content pre {
  background: #2d2d2d;
  color: #ccc;
}

.vod-guide-viewer {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DataViewer/VodGuide.vue